<pp-status-icon [iconName]="iconName()" [status]="status()" size="small">
</pp-status-icon>

<div class="custom-content">
  <ng-content select="[beforeContent]"></ng-content>
</div>

<div class="content">
  <div class="label">
    {{ label() }}
  </div>

  @if (title()) {
    <h4 class="title">
      {{ title() }}
    </h4>
  }
</div>

<div class="message">
  {{ subTitle() }}
</div>

<ng-content select="[afterTitle]"></ng-content>

<div class="pp-form-actions">
  <button
    type="button"
    puButton
    size="m"
    uiType="secondary"
    (click)="discard.emit()">
    {{ cancelCaption() }}
  </button>
  <button
    type="button"
    [disabled]="isOkDisabled()"
    puButton
    size="m"
    uiType="primary"
    (click)="ok.emit()">
    {{ okCaption() }}
  </button>
</div>
